import { render, staticRenderFns } from "./processTestimony.vue?vue&type=template&id=37cce89d&scoped=true&"
import script from "./processTestimony.vue?vue&type=script&lang=js&"
export * from "./processTestimony.vue?vue&type=script&lang=js&"
import style0 from "./processTestimony.vue?vue&type=style&index=0&id=37cce89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cce89d",
  null
  
)

export default component.exports